import Cam from "components/display/Cam";
import styled from "styled-components"

const Wrapper = styled.div`
  position: relative;
  width: 1920px;
  height: 2160px;
  display: flex;
  justify-content: center;
  background-color: #f0f0f0;
  font-family: 'Montserrat', sans-serif;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

const RestComponentWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 40px;
`;

const RestComponents = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  position: absolute;
  top: -20px;
  left: 20px;
`;

const Logo = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`;

const KST = styled.div`
  position: absolute;
  right: 0;
  top: 34px;
`;

const Timer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  justify-content: center;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 32px;
  font-weight: 600;
  gap: 16px;
  letter-spacing: 2px;

  span:first-child {
    position: relative;
    top: -4px;
    font-size: 22px;
  }
`;

const CamWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export default function GUI() {
  return <>
    <img src="/assets/display/all.jpg" style={{position: "absolute", zIndex: 10}} />
    {/* <Wrapper>
      <Background>
        <img src="/assets/display/background.png" />
      </Background>
      <CamWrapper>
        <Cam isGray title="HWACHUN" top={74} left={936} />
      </CamWrapper>
      <RestComponentWrapper>
        <RestComponents>
          <Title>
            <img src="/assets/display/kepler.png" />
          </Title>
          <KST>
            <img src="/assets/display/kst.png" />
            <Timer>
              <span>KST</span>
              <span>{`2024-09-11 16:01:45`}</span>
            </Timer>
          </KST>
          <Logo>
            <img src="/assets/display/logo.png" />
          </Logo>
        </RestComponents>
      </RestComponentWrapper>
    </Wrapper> */}
  </>
}